module.exports = __webpack_public_path__ + "img/9788958283522.e2e1bf11.jpg";